// React
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
// Style
import "../../styles/menu/MenuStyle.scss";
import "../../styles/menu/AdminStyle.scss";
// Recoil
import { useRecoilState, useResetRecoilState } from "recoil";
import {
  tableState,
  templateState,
  orderState,
  customPayType,
  cartState,
} from "../../atom/menu";

type popupProp = {
  action: () => void;
};

function AdminMain(props: popupProp) {
  // 관리자 화면

  const navigate = useNavigate();
  // Recoil State
  const resetTable = useResetRecoilState(tableState);
  const resetOrder = useResetRecoilState(orderState);
  const resetCart = useResetRecoilState(cartState);
  const [template, setTemplate] = useRecoilState(templateState);
  const [toggleStatusPrePay, setToggleStatusPrePay] =
    useRecoilState(customPayType);
  // useState
  const [toggleStatus, setToggleStatus] = useState<boolean>(true);
  const [robotPopup, setRobotPopup] = useState<boolean>(false);

  // Function
  const templateSwicth = () => {
    if (template === 0) {
      setTemplate(1);
    } else {
      setTemplate(0);
    }
    props.action();
  };

  const resetTableEvent = () => {
    // 테이블 비우기 (관련 전역값 리셋)
    resetTable();
    resetCart();
    resetOrder();
    props.action();
  };

  return (
    <div className='admin-popup-bg'>
      <div
        className='admin-popup-wrap'
        style={{ width: "936px", height: "680px", padding: 6, margin: "auto" }}
      >
        <div className='admin-header-wrap'>
          <div className='flex row h-auto' style={{ gap: 8 }}>
            <div
              className='basic-btn white TO-button-1 pointer'
              style={{ maxWidth: "100%" }}
              onClick={() => {
                resetTableEvent();
              }}
            >
              테이블비움
            </div>
            <div
              className='basic-btn white TO-button-1 pointer'
              style={{ maxWidth: "100%" }}
              onClick={() => {
                setRobotPopup(!robotPopup);
              }}
            >
              로봇 호출
            </div>
          </div>
          <div className='img-box'>
            <img
              src={"/assets/images/menu/close_black.svg"}
              alt='page back'
              onClick={() => {
                props.action();
              }}
            />
          </div>
        </div>

        <div className='flex col' style={{ padding: "35px 56px 40px" }}>
          <div className='admin-wrap'>
            <div className='admin-row'>
              <div
                className='TO-title-4 text-color-gray-6'
                style={{ minWidth: 230 }}
              >
                개점 마감
              </div>
              <div className='pointer'>
                {toggleStatus ? (
                  <img
                    src={"/assets/images/menu/swicth.svg"}
                    alt='swicth_on'
                    onClick={() => {
                      setToggleStatus(!toggleStatus);
                      setTimeout(() => {
                        navigate("/close");
                        props.action();
                      }, 100);
                    }}
                  />
                ) : (
                  <img
                    src={"/assets/images/menu/swicth_off.svg"}
                    alt='swicth_off'
                    onClick={() => {
                      setToggleStatus(!toggleStatus);
                    }}
                  />
                )}
              </div>
            </div>
            {/* <div className='admin-row'>
              <div
                className='TO-title-4 text-color-gray-6'
                style={{ minWidth: 230 }}
              >
                테이블 기기 정보
              </div>
              <div className='TO-title-3 text-color-gray'>
                DKLL-9789-KJHH-3848-5483
              </div>
            </div>
            <div className='admin-row'>
              <div style={{ minWidth: 230 }}></div>
              <div className='TO-title-3 text-color-gray'>VD3598993959</div>
            </div> */}
            <div className='admin-row'>
              <div
                className='TO-title-4 text-color-gray-6'
                style={{ minWidth: 230 }}
              >
                매장명
              </div>
              <div className='TO-title-3 text-color-gray'>1992 덮밥&짜글이</div>
            </div>
            <div className='admin-row'>
              <div
                className='TO-title-4 text-color-gray-6'
                style={{ minWidth: 230 }}
              >
                테이블명
              </div>
              <div className='TO-title-3 text-color-gray'>2층 13</div>
            </div>
            {/* <div className='admin-row align-items-center h-auto'>
              <div
                className='TO-title-5 text-color-gray-5'
                style={{ minWidth: 230 }}
              >
                Ver. 1.30.5
              </div>
              <div className='flex row h-auto' style={{ gap: 16 }}>
                <div
                  className='basic-btn white TO-button-1'
                  style={{ maxWidth: 147, padding: "24px 22px" }}
                >
                  초기화
                </div>
                <div
                  className='basic-btn white TO-button-1'
                  style={{
                    maxWidth: 147,
                    padding: "24px 22px",
                  }}
                >
                  종료
                </div>
                <div
                  className='basic-btn white T24M'
                  style={{ padding: "24px 12px" }}
                >
                  재시작 및 업데이트
                </div>
              </div>
            </div> */}
          </div>
          <div className='admin-button-wrap'>
            <div
              className='basic-btn white TO-button-1 pointer'
              style={{ maxWidth: "100%" }}
              onClick={() => {
                templateSwicth();
              }}
            >
              가로/세로 템플릿 전환
            </div>
            <div className='admin-row center' style={{ width: 287 }}>
              <div
                className='TO-title-4 text-color-gray-6'
                style={{ minWidth: "fit-content" }}
              >
                선결제
              </div>
              <div className='pointer'>
                {toggleStatusPrePay ? (
                  <img
                    src={"/assets/images/menu/swicth.svg"}
                    alt='swicth'
                    onClick={() => {
                      setToggleStatusPrePay(!toggleStatusPrePay);
                    }}
                  />
                ) : (
                  <img
                    src={"/assets/images/menu/swicth_off.svg"}
                    alt='swicth_off'
                    onClick={() => {
                      setToggleStatusPrePay(!toggleStatusPrePay);
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {robotPopup && (
          <PopupCallRobot isView={robotPopup} setIsView={setRobotPopup} />
        )}
      </div>
    </div>
  );
}

export default AdminMain;

type PopupViewPropsTypes = {
  isView: boolean;
  setIsView: React.Dispatch<React.SetStateAction<boolean>>;
};
function PopupCallRobot(props: PopupViewPropsTypes) {
  const clickAction = () => {
    props.setIsView(!props.isView);
  };
  return (
    <div className='admin-popup-bg col' style={{ padding: 0 }}>
      <img
        className='pointer'
        src={"/assets/images/menu/close_white.svg"}
        alt='page back'
        style={{
          width: 24,
          position: "absolute",
          top: 36,
          right: 36,
        }}
        onClick={() => {
          clickAction();
        }}
      />
      <div
        className='admin-popup-wrap'
        style={{
          borderRadius: 0,
          height: 296,
          backgroundColor: "transparent",
          paddingBottom: 36,
        }}
      >
        <div
          className='TO-title-1'
          style={{ textAlign: "center", color: "#D8D8D8" }}
        >
          브이디로봇이
          <br />
          정상적으로 호출되었습니다.
        </div>
      </div>
      <div
        className='flex col center relative'
        style={{
          justifyContent: "flex-end",
        }}
      >
        <img
          src={"/assets/images/menu/bot.gif"}
          alt='bot'
          style={{ width: 748, position: "absolute", bottom: 186 }}
        />
        <div
          className='basic-btn TO-button-1 pointer'
          style={{ maxWidth: 748, marginBottom: 90 }}
          onClick={() => {
            clickAction();
          }}
        >
          확인
        </div>
      </div>
    </div>
  );
}
